import { createUseStyles } from 'react-jss'
import { style as pageStyle } from './create-page.style'

export const style = {
  form: pageStyle.form
}

export const useStyles = createUseStyles(style)
